import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { format } from 'date-fns';
import { FlowFormData, flowFormSchema } from '../validations/flowForm';
import { FLOW_TRIGGER } from '../constants/flowTriggers';
import { DATE_FORMATS } from '@/lib';
import { getDefaultTimezoneOption } from '@/components/core-components/StanTimezoneSelector';
import { getDefaultScheduleTime } from '../logic/timeValidation.logic';

export const useAddFlowForm = () => {
    const form = useForm<FlowFormData>({
        resolver: zodResolver(flowFormSchema),
        mode: 'onChange',
        defaultValues: {
            flowName: '',
            selectedTrigger: FLOW_TRIGGER.CHECKOUT,
            selectedProducts: [0], // 0 = All Products
            selectedExcludeProducts: [],
            selectedDate: format(new Date(), DATE_FORMATS.ISO_8601),
            selectedTime: getDefaultScheduleTime(),
            selectedTimezone: getDefaultTimezoneOption().value,
            tags: [],
        },
    });

    return form;
};
